/*
 * @Description: 谷歌登陆组件
 * @Author: kadenwang@tencent.com
 * @Date: 2021-11-12 16:05:41
 * @LastEditors: yanxia@tencent.com
 * @LastEditTime: 2022-04-27 16:26:33
 */

import { getRedirectUrl, isAppMarket } from '@tencent/syzs-login-sdk-utils';
import { useCallback } from 'react';
import { GoogleLogin } from 'react-google-login';
import i18n from '../../i18n';
import { itemLoginTypeKey, postMessageToParent } from '../../lib';
import { ILoginType } from '../../types';
import './index.less';

const CLIENT_ID = '543057759759-gor4il8dbu1gbk28a6vmhor5a8sv4fko.apps.googleusercontent.com';

export interface IResponseGoogle {
  code: string;
}

export const GoogleLoginButton = () => {
  const responseGoogle = useCallback(() => {
    // NOT WORK !!!!! WE UESD REDIRECT
    // if (!response.code) return;

    // void code2AccessToken(response.code, ILoginType.gg);
  }, []);

  return (
    <div className="login-v2-google-login">
      <GoogleLogin
        clientId={CLIENT_ID}
        buttonText="Login"
        onSuccess={responseGoogle}
        onFailure={responseGoogle}
        cookiePolicy="single_host_origin"
        render={() => (
          <div
            onClick={() => {
              window.report('syzs_login_v2_google_button_click');
              // 用自己的方式登陆
              localStorage.setItem(itemLoginTypeKey, ILoginType.gg);
              const url = `https://accounts.google.com/o/oauth2/v2/auth?response_type=code&client_id=${CLIENT_ID}&prompt=select_account&scope=openid+email+profile&redirect_uri=${encodeURIComponent(getRedirectUrl())}&flowName=GeneralOAuthFlow`;
              if (isAppMarket()) {
                location.href = url;
              } else {
                void postMessageToParent('OPEN_LOGIN_PAGE', url, false);
              }
            }}
            className="google-button"
          >
            <i className="login-logo" />
            <span className="text">{i18n.l('GoogleBookLogin')}</span>
          </div>
        )}
      />
    </div>
  );
};
